<template>
  <div id="conditions" class="conditions">
    <div class="conditions__box">
      <div class="conditions__title">
        Условия заезда и отъезда детей в смену
      </div>
      <div class="conditions__card">
        <ul>
          <li class="conditions__card-text">
            После покупки путевки Вы можете заранее забронировать место в отряде
            для своего ребёнка или группы детей. Информация по дню и времени
            записи в отряды публикуется в наших соцсетях
            <a
              target="_blank"
              href="https://t.me/berezka64_camp"
              class="footer__info-social"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 51 51"
                fill="#000"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M42.7619 6.77275C42.2093 6.79713 41.6945 6.95809 41.2412 7.1413C40.8166 7.31209 39.1944 8.00786 36.6393 9.10361C34.0819 10.2003 30.6956 11.6541 27.0834 13.2075C19.8589 16.3143 11.7368 19.8114 7.57656 21.6013C7.42013 21.6685 6.87427 21.8429 6.29492 22.2952C5.71557 22.7475 5.09961 23.6847 5.09961 24.729C5.09961 25.5711 5.50092 26.4076 6.00605 26.9071C6.51119 27.4066 7.04568 27.6533 7.50352 27.8401C9.1647 28.5179 14.3168 30.6263 15.2896 31.0243C15.632 32.0732 17.4968 37.7776 17.9293 39.1757C18.2144 40.0983 18.4857 40.6761 18.8391 41.1347C19.0157 41.3639 19.2211 41.5649 19.4699 41.7224C19.5694 41.7853 19.6785 41.8338 19.7887 41.8784L19.7953 41.8817C19.8207 41.8919 19.8426 41.9092 19.8684 41.9183C19.917 41.9352 19.9495 41.9373 20.0145 41.9515C20.2734 42.0351 20.5348 42.0876 20.7682 42.0876C21.7629 42.0876 22.3719 41.5397 22.3719 41.5397L22.4084 41.5132L27.525 37.0872L33.7307 42.9575C33.818 43.0811 34.6329 44.1993 36.4301 44.1993C37.4972 44.1993 38.3437 43.6639 38.8871 43.0936C39.4306 42.5234 39.7692 41.9244 39.9131 41.1712V41.1679C40.0477 40.4561 45.7668 11.0958 45.7668 11.0958L45.7568 11.1356C45.9243 10.3715 45.9681 9.6598 45.7834 8.95751C45.5987 8.25523 45.1119 7.58282 44.5084 7.22099C43.9049 6.85924 43.3145 6.74837 42.7619 6.77275ZM42.4432 10.3255C42.435 10.3751 42.4493 10.3501 42.4365 10.4085L42.4332 10.4284L42.4299 10.4483C42.4299 10.4483 36.7816 39.4331 36.5729 40.537C36.5881 40.4536 36.5183 40.6194 36.4467 40.7196C36.3454 40.6498 36.1379 40.5602 36.1379 40.5602L36.1047 40.5237L27.6279 32.5052L21.6348 37.6849L23.4178 30.5462C23.4178 30.5462 34.5633 19.0089 35.2348 18.3374C35.7754 17.8002 35.8889 17.6129 35.8889 17.4276C35.8889 17.1794 35.7595 16.9993 35.4705 16.9993C35.2104 16.9993 34.8606 17.2522 34.6736 17.3712C32.2374 18.9242 21.5417 25.1578 16.7473 27.9464C15.9854 27.6346 10.692 25.4678 8.89805 24.7356C8.91163 24.7297 8.90716 24.7318 8.92129 24.7257C13.0826 22.9353 21.2014 19.4382 28.4248 16.3319C32.0365 14.7788 35.4254 13.3238 37.9807 12.228C40.4966 11.1491 42.2448 10.4065 42.4432 10.3255Z"
                  fill="#000"
                />
              </svg>
            </a>
            <a
                target="_blank"
                href="https://max.ru/id6455072031_biz"
                class="footer__info-social"
            >
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.3405 23.9342C9.97568 23.9342 8.87728 23.5899 6.97252 22.2125C5.76041 23.762 1.94518 24.9672 1.77774 22.9012C1.77774 21.3535 1.42788 20.0492 1.04269 18.6132C0.570922 16.8544 0.0461426 14.898 0.0461426 12.0546C0.0461426 5.27426 5.6424 0.175079 12.2777 0.175079C18.913 0.175079 24.1153 5.52322 24.1153 12.1205C24.1153 18.7178 18.7474 23.9342 12.3405 23.9342ZM12.4368 6.03673C9.20791 5.86848 6.68817 8.0948 6.13253 11.5794C5.6724 14.465 6.48821 17.9812 7.18602 18.1582C7.51488 18.2416 8.35763 17.564 8.87711 17.0475C9.73154 17.5981 10.712 18.0245 11.8019 18.0813C15.1168 18.254 18.0544 15.6761 18.228 12.382C18.4016 9.08792 15.7517 6.20946 12.4368 6.03673Z" fill="black"></path></svg>
            </a>
            <a
              target="_blank"
              href="https://vk.com/berezka64_camp"
              class="footer__info-social"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.7365 2.7365C0 5.473 0 9.8787 0 18.6875V20.3125C0 29.12 0 33.527 2.7365 36.2635C5.473 39 9.8787 39 18.6875 39H20.3125C29.12 39 33.527 39 36.2635 36.2635C39 33.527 39 29.1213 39 20.3125V18.6875C39 9.88 39 5.473 36.2635 2.7365C33.527 0 29.1213 0 20.3125 0H18.6875C9.88 0 5.473 0 2.7365 2.7365ZM7.71934 12.1882H10.5624C11.2891 12.1882 11.5621 12.5067 11.8351 13.2945C13.2261 17.3453 15.5713 20.8865 16.5346 20.8865C16.8973 20.8865 17.0624 20.7201 17.0624 19.801V15.6137C16.9973 14.4217 16.5809 13.9061 16.2724 13.5242C16.082 13.2884 15.9327 13.1036 15.9327 12.8421C15.9327 12.5236 16.2044 12.1882 16.6555 12.1882H21.1249C21.7281 12.1882 21.9374 12.5106 21.9374 13.2334V18.8676C21.9374 19.4695 22.1987 19.6814 22.3794 19.6814C22.7408 19.6814 23.0424 19.4695 23.7054 18.8065C25.7542 16.5172 27.1998 12.9929 27.1998 12.9929C27.3805 12.5704 27.7146 12.1882 28.4374 12.1882H31.2805C32.1411 12.1882 32.3231 12.6315 32.1411 13.2334C31.7797 14.8909 28.3152 19.7711 28.3152 19.7711C28.0136 20.2534 27.8927 20.4939 28.3152 21.036C28.4643 21.2448 28.7824 21.5566 29.1461 21.9131C29.5181 22.2777 29.9378 22.6891 30.273 23.0848C31.495 24.4589 32.4154 25.6185 32.6715 26.4167C32.9068 27.2188 32.4999 27.6257 31.6874 27.6257H28.843C28.0815 27.6257 27.6984 27.1992 26.8698 26.2769C26.5187 25.8861 26.0876 25.4062 25.5137 24.832C23.825 23.2057 23.1035 22.9951 22.681 22.9951C22.109 22.9951 21.9374 23.1576 21.9374 23.9701V26.5207C21.9374 27.2188 21.7138 27.6257 19.9055 27.6257C16.8934 27.6257 13.5823 25.7966 11.2332 22.4218C7.70764 17.4818 6.74434 13.7456 6.74434 12.9929C6.74434 12.5704 6.90684 12.1882 7.71934 12.1882Z"
                  fill="#000"
                />
              </svg>
            </a>
            за несколько дней до начала смены
          </li>
          <li class="conditions__card-text">
            Заезд в лагерь происходит организованно с 7:00 до 12:00 в первый
            день смены. Вас встретят у главных ворот сотрудники лагеря и помогут
            пройти процедуру регистрации и медосмотр ребенка.
          </li>
          <li class="conditions__card-text">
            Время заезда регламентировано, т.к. до обеда необходимо сформировать
            заявку с точным количеством детей на питание и размещение в отрядах.
          </li>
          <li class="conditions__card-text">
            Для комфортной психологической адаптации ребенка привозите его в
            строго установленное время.
          </li>
          <li class="conditions__card-text">
            Для ускорения прохождения процедуры регистрации при заезде, заранее
            распечатайте и подпишите
            <a
              target="_blank"
              href="https://drive.google.com/file/d/1QFXs9NEDjusVu-zRT9vDTkFSyiWDSE3y/view?usp=sharing"
              class="conditions__card-link"
              >Медсогласие</a
            >. Предъявите подписанный документ на заезде.
          </li>
          <li class="conditions__card-text">
            Отъезд осуществляется в последний день смены до 13:00.
          </li>
          <li class="conditions__card-text">
            Заезд и отъезд осуществляются силами родителей или опекунов.
          </li>
        </ul>
        <img
          class="conditions__card-image"
          src="@/assets/images/photo/conditions.jpg"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.conditions {
  background: linear-gradient(
    265.82deg,
    #5ec0a9 4.04%,
    rgba(13, 175, 150, 0.81) 64.05%
  );
  padding: 60px 0 90px;
  position: relative;
  &::before {
    background-image: url("~@/assets/images/photo/conditions-bg.png");
    background-size: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    content: "";
  }
  &__box {
    max-width: 1080px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
    @media screen and (max-width: 1300px) {
      max-width: 620px;
    }
    @media screen and (max-width: 680px) {
      max-width: 300px;
    }
  }
  &__title {
    font-family: RF Dewi Expanded;
    font-size: 58px;
    font-weight: 900;
    line-height: 70px;
    color: white;
    margin: 0 0 30px;
    @media screen and (max-width: 1300px) {
      font-size: 46px;
      line-height: 55px;
    }
    @media screen and (max-width: 680px) {
      font-size: 24px;
      line-height: 29px;
    }
  }
  &__card {
    display: flex;
    justify-content: space-between;
    background-color: white;
    border-radius: 30px;
    padding: 48px;
    ul {
      padding-inline-start: 20px;
    }
    @media screen and (max-width: 1300px) {
      justify-content: center;
      flex-wrap: wrap;
    }
    @media screen and (max-width: 680px) {
      padding: 30px 12px;
    }
    &-text {
      float: left;
      font-family: Montserrat;
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      margin-bottom: 22px;
      @media screen and (max-width: 1300px) {
        width: 100%;
      }
      @media screen and (max-width: 680px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    &-link {
      font-family: Montserrat;
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      color: black;
      @media screen and (max-width: 680px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    &-image {
      object-fit: contain;
      @media screen and (max-width: 680px) {
        width: 236px;
        height: 236px;
      }
    }
  }
}
</style>
